import { Link } from 'src/components/atoms';
import styled from 'styled-components';
import { QuestionInputContainer } from '../TextQuestion/TextQuestion.styles';

export const InputContainer = styled(QuestionInputContainer)`
  width: 88%;
  padding: 0 20px;
  margin-top: 20px;
  gap: 10px;
  justify-content: flex-start;
`;
export const QuestionDescription = styled.p`
  ${(props) => props.theme.newTypography.textStyleBodySmall}
  display: flex;
  justify-content: center;
  align-items: flex-start;
  text-align: center;
  color: ${(props) => props.theme.newPalette.neutral.N800};
  margin: 0;
`;

export const IntercomLink = styled(Link)`
  ${(props) => props.theme.newTypography.textStyleBodySmall};
`;
export const StyledText = styled.p`
  ${(props) => props.theme.newTypography.textStyleBodySmall};
  margin: 0;
`;
